import VueCookie from 'vue-cookie';
import store from '@/store';
import router from '@/router';
import configLauncherDownload from '@/config/config-dowloadLauncher';

const downloadLauncher = (region) => {
    const getLauncherType = () => {
            if (region === 'global') {
                return '';
            }
            return `_${region.toUpperCase()}`;
        },
        launcherType = getLauncherType(),
        { productId } = store.state,
        partnerKey = router.currentRoute.query.partnerkey || VueCookie.get('partner_key'),
        base = new URL(configLauncherDownload.LauncherDownloadHost[process.env.VUE_APP_ENV]);

    base.searchParams.set('file', `NexonLauncherSetup${launcherType}.exe`);

    try {
        // window.ga.getAll() has an issue on FF in private mode
        base.searchParams.set('client-id', window.ga.getAll()[0].get('clientId'));
    } catch (e) {
        console.error(e);
    }

    if (productId) {
        base.searchParams.set('product-id', productId);
    }
    if (partnerKey) {
        base.searchParams.set('partnerkey', partnerKey);
    }
    dataLayer.push({ event: 'registrationLauncherDownload' });
    window.location = base.href;
};

export default downloadLauncher;
